let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aiSmh")).then(() => parcelRequire('hmHQM'));